import React from 'react';

import { formatDate } from 'Helpers/dateUtils';

export default function VenueTooltip({ venue }) {
    return (
        <div className="tw-text-charcoal">
            <div className="tw-mb-3 tw-uppercase tw-font-extrabold">{venue.name}</div>
            <div className="tw-space-y-1">
                {!!venue.sports?.length && (
                    <div className="tw-grid tw-grid-cols-2 tw-gap-x-4">
                        <div>{$t('Sports Allocated')}</div>
                        <div className="tw-font-bold tw-flex tw-flex-wrap tw-gap-2">
                            {venue.sports.map((sport, index) => (
                                <React.Fragment key={sport.id}>
                                    <span>{sport.name}</span>
                                    {index < venue.sports.length - 1 && ', '}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                )}
                <div className="tw-grid tw-grid-cols-2 tw-gap-x-5">
                    <div>{$t('Capacity Permanent')}</div>
                    <div className="tw-font-bold">{venue.capacity_permanent || 0}</div>
                </div>
                <div className="tw-grid tw-grid-cols-2 tw-gap-x-5">
                    <div>{$t('Capacity Temporary')}</div>
                    <div className="tw-font-bold">{venue.capacity_temp || 0}</div>
                </div>
                <div className="tw-grid tw-grid-cols-2 tw-gap-x-5">
                    <div>{$t('Hire Start')}</div>
                    <div className="tw-font-bold">{formatDate(venue.hire_start)}</div>
                </div>
                <div className="tw-grid tw-grid-cols-2 tw-gap-x-5">
                    <div>{$t('Hire End')}</div>
                    <div className="tw-font-bold">{formatDate(venue.hire_end)}</div>
                </div>
                <div className="tw-grid tw-grid-cols-2 tw-gap-x-5">
                    <div>{$t('Competition')}</div>
                    <div className="tw-font-bold">{venue.competition ? $t('Yes') : $t('No')}</div>
                </div>
            </div>
        </div>
    );
}
